var _path, _rect, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9045 0.216721C9.87616 0.216721 6.28182 0.226155 3.25352 0.226155H3.21579C1.79126 0.226155 0.79126 1.32049 0.79126 2.9337C0.79126 6.90539 0.79126 10.8677 0.79126 14.8393C0.79126 18.811 0.79126 19.9431 0.79126 23.9148C0.79126 25.528 1.79126 26.6224 3.21579 26.6224H18.329C19.8101 26.6224 20.7912 25.5469 20.7912 23.8959V9.20728C18.4705 9.20728 12.895 2.85823 12.895 0.216721H12.9045Z",
    fill: "url(#paint0_linear_5968_19465)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.62634,
    y: 12.6213,
    width: 12.3298,
    height: 10.1608,
    rx: 2,
    fill: "#1A2037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9039 0.216721V7.63181C12.9039 8.72614 13.3379 9.21671 14.319 9.21671H20.7907C20.7907 9.21671 20.7907 9.24501 20.7907 9.21671L12.9039 0.216721Z",
    fill: "url(#paint1_linear_5968_19465)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3619 15.8695C14.6359 16.216 14.5771 16.7191 14.2306 16.9932L10.2551 20.1366C9.93285 20.3914 9.47006 20.3607 9.18426 20.0657L7.27362 18.0933C6.9662 17.776 6.97425 17.2695 7.29159 16.9621C7.60894 16.6547 8.1154 16.6628 8.42282 16.9801L9.83013 18.4328L13.2382 15.7381C13.5848 15.4641 14.0879 15.5229 14.3619 15.8695Z",
    fill: "#BFC0C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5968_19465",
    x1: -0.321947,
    y1: 45.594,
    x2: 14.6592,
    y2: 2.24502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5968_19465",
    x1: 27.6082,
    y1: -5.36914,
    x2: 6.37201,
    y2: 16.3064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.200454ffc7c9e62c94fce2fe678da026.svg";
export { ForwardRef as ReactComponent };